import accountReducer from "./accountReducer";

const accountReducers = {
    account: accountReducer
}

export default accountReducers;